/*
 * File: ClientSelected.tsx
 * Project: a-a
 * File Created: Sunday, 5th January 2025 12:27:53 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Friday, 14th November 2025 11:05:03 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { DashboardService } from '../../../../service/dashboard.service';
import OverviewTab from '../../../shared/CustomDashboard/Overview/OverviewTab';
import ActivityTab from '../../../shared/CustomDashboard/ActivityTab/ActivityTab';
import TaskTab from '../../../shared/CustomDashboard/TaskTab/TaskTab';
import CustomHeadline from '../../../shared/CustomHeadline/CustomHeadline';
import zeplinColor from '../../../../theme/Color';
import DashboardDealCard from '../../../shared/CustomDashboard/Overview/DashboardDealCard';
import { ClientType, Constants } from '../../../../utilities/constants';
import CustomCard from '../../../shared/CustomCard/CustomCard';
import CustomTab from '../../../shared/CustomTab/CustomTab';
import CustomAlert from '../../../shared/CustomAlert/CustomAlert';
import CustomAlertContain from '../../../shared/CustomAlert/CustomAlertContain';
import CustomHomepage from '../../../shared/CustomHomePage/CustomHomepage';
import CustomButton from '../../../shared/CustomButton/CustomButton';
import ActivityColumn from '../../../shared/CustomDashboard/Overview/Activity/ActivityColumn';
import TaskColumn from '../../../shared/CustomDashboard/Overview/Tasks/TaskColumn';
import AccountColumn from '../../../shared/CustomDashboard/Overview/AccountColumn';
import TodaysMeeting from '../../../shared/CustomDashboard/Overview/TodaysMeeting';
import SocialEngagement from '../../../shared/CustomDashboard/Overview/SocialEngagement';
import KeyDeals from '../../../shared/CustomDashboard/Overview/KeyDeals';
import CustomDrawer from '../../../shared/CustomDrawer/CustomDrawer';
import { Chip, Divider, Drawer, Skeleton, useTheme } from '@mui/material';
import KeyDealsTab from '../../../shared/CustomDashboard/KeyDealsTab/KeyDealsTab';
import ContactTab from '../../../shared/CustomDashboard/ContactsTab/ContactTab';
import { ClientService } from '../../../../service/client.service';
import CustomLoader from '../../../shared/CustomLoader/CustomLoader';
import formatCurrency from '../../../../helper/short-currency';
import SocialEngagementTab from '../SocialEngagementTab/SocialEngagementTab';
import style from './ClientSelected.module.css';
import CustomBox from '../../Box/Box';
import CustomPopOver from '../../../shared/CustomPopOver/CustomPopOver';
import CustomModal from '../../../shared/CustomModal/CustomModal';
import BusinessForm from '../../../../pages/Dashboard/Client/ClientForm/Forms/BusinessForm';
import AtheleteForm from '../../../../pages/Dashboard/Client/ClientForm/Forms/AtheleteForm';
import TalentForm from '../../../../pages/Dashboard/Client/ClientForm/Forms/TalentForm';
import ClientDrawer from '../../../../pages/Dashboard/Client/ClientForm/FormDrawer/ClientDrawer';
import TalentDetails from './TalentDetails';
import AtheleteDetails from './AtheleteDetails';
import BusinessDetails from './BusinessDetails';
import { LightTooltip } from '../../../shared/CustomTooltip/CustomTooltip';
import { cp } from 'fs';
import LinkingForm from '../../../../pages/Dashboard/Client/ClientForm/Forms/LinkingForm';
const drawerWidth = 240;
type SportsProps = {
  link: '';
  title: '';
  source: '';
};

const ClientSelected = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const client = location.state?.client;
  const sf_token = sessionStorage.getItem('SFToken') || '';
  const new_client = sessionStorage.getItem('new-client') || '';
  const captive8IdStored = sessionStorage.getItem('captive8Id');
  const sf_delete = sessionStorage.getItem('sf_delete') || '';
  const sf_edit = sessionStorage.getItem('sf_edit') || '';
  const captive8UrlStored = sessionStorage.getItem('captive8Url');
  const currentTab = sessionStorage.getItem('currentTab') || '0';
  const sf_redirect = sessionStorage.getItem('sf_redirect') || '';
  const params = useParams();
  const theme = useTheme();
  const userName = sessionStorage.getItem('user-name') || '';
  const today = new Date();

  const formattedDate = today.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
  // tab functionality
  const [value, setValue] = React.useState(0);
  const [alert, setAlert] = React.useState('');
  const [drawerState, setDrawerState] = React.useState(false);
  const onClose = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }
    setDrawerState(open);
  };
  const onOpen = () => {
    getDetails(params.id || '');
    setDrawerState(true);
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    sessionStorage.setItem('currentTab', newValue.toString());
    sessionStorage.removeItem('dealSelectedFromOverview');
    setValue(newValue);
  };

  const handleClose = () => {
    setAlert('');
  };
  // data from api
  const [data, setData] = React.useState<any>();
  const [details, setDetails] = React.useState<any>();
  const [loading, setLoading] = React.useState(false);
  const [openModal, setOpenModal] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null);
  const [action, setAction] = React.useState('');
  const [captive8loading, setCaptive8Loading] = React.useState(false);
  const [creatorInfo, setCreatorInfo] = React.useState<any>(null);
  const [editModal, setEditModal] = React.useState(false);
  const [linkModal, setLinkModal] = React.useState(false);
  const [sportsData, setSportsData] = React.useState<SportsProps[]>([
    {
      link: '',
      title: '',
      source: '',
    },
  ]);
  const [copy, setCopy] = React.useState('');
  const handleCopyLink = (val: any) => {
    // console.log() .
    navigator.clipboard.writeText(val);
    // setCopy('Link Copied');
    setAlert('Link Copied');
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const getDetails = async (id: string) => {
    setLoading(true);
    try {
      if (id) {
        const res = await ClientService.getClientDetails(id);
        getCreatorInfo(res?.captiv8Id);
        console.log(res);
        setDetails(res);
      }
    } catch (err: any) {
      setAlert(err?.message as string);
    } finally {
      setLoading(false);
    }
  };
  const getDeal = async (id: string) => {
    try {
      const res = await ClientService.getClientDeal(id);

      setData(res);
    } catch (err: any) {
      setAlert(err?.message as string);
    }
  };
  const getSportNews = async () => {
    try {
      const res: { latestNews: SportsProps[] } = await DashboardService.getSportNews();

      setSportsData(res?.latestNews);
    } catch (err: any) {
      setAlert(`sports api : ${err?.message as string}`);
    }
  };

  const getCreatorInfo = async (id: string) => {
    try {
      setCaptive8Loading(true);
      const res = await ClientService.getCreatorInfo(id);
      // sessionStorage.setItem('captive8Id', client?.captiv8Id || captive8IdStored);
      // sessionStorage.setItem('captive8Url', client?.captiv8Url || captive8UrlStored);
      console.log(res);
      setCreatorInfo(res);
    } catch (err) {
      if (!client?.captiv8Id) {
        // setError('Client not found in Captive8');
      } else {
        // setError('Something went wrong');
      }
    } finally {
      setCaptive8Loading(false);
    }
  };

  React.useEffect(() => {
    getDeal(params.id || '');
    getSportNews();
    getDetails(params.id || '');
    // getCaptive8Info();

    new_client === 'true' && setLinkModal(true);
    sf_redirect === 'Task' && setValue(2);
    sf_redirect === 'Overview' && setValue(0);
    sf_redirect === 'Deals' && setValue(3);
    sf_redirect === 'Activity' && setValue(1);
    if (!sf_redirect) {
      setValue(+currentTab || 0);
    }
  }, []);
  React.useEffect(() => {
    const handleSFTokenAuth = (e: CustomEvent) => {
      if (e.detail.key === 'SFToken') {
        if (e.detail.value === 'true' && !openModal) {
          sf_delete === 'true' && handleOpen();
          sf_edit === 'true' && setEditModal(true);
        }
      }
    };

    // Add event listener
    window.addEventListener('sessionStorageChange', handleSFTokenAuth as EventListener);

    // Cleanup
    return () => {
      window.removeEventListener('sessionStorageChange', handleSFTokenAuth as EventListener);
    };
  }, []);
  const handleOpen = () => setOpenModal((prev) => !prev);

  const DashboardTabs = [
    {
      label: 'Overview',
      id: 1,
      isHidden: value !== 0,
      Component: (
        <Box>
          <OverviewTab
            channelID={client?.slackChannelId}
            setActiveTab={setValue}
            Column1={ActivityColumn}
            Column2={TaskColumn}
            Column3={SocialEngagement}
            creatorInfo={creatorInfo}
            AlternatColumn3={SocialEngagement}
            Column4={KeyDeals}
            setValue={setValue}
            captive8Url={client?.captive8Url}
            captive8Loading={captive8loading}
          />
        </Box>
      ),
    },
    {
      label: 'Activity',
      id: 2,
      isHidden: value !== 1,
      Component: (
        <Box>
          <ActivityTab />
        </Box>
      ),
    },
    {
      label: 'Task',
      id: 3,
      isHidden: value !== 2,
      Component: (
        <Box>
          <TaskTab />
        </Box>
      ),
    },
    {
      label: 'Deals',
      id: 4,
      isHidden: value !== 3,
      Component: (
        <Box>
          <KeyDealsTab getDeal={() => getDeal(params.id || '')} />
        </Box>
      ),
    },
    {
      label: 'Social Engagement',
      id: 5,
      isHidden: value !== 4,
      Component: (
        <Box>
          <SocialEngagementTab
            key={details?.captive8Id || captive8IdStored}
            captive8Id={details?.captiv8Id || captive8IdStored}
            captive8Url={details?.captive8Url || captive8UrlStored}
            getDetails={() => {
              getDetails(params.id || '');
            }}
          />
        </Box>
      ),
    },
    {
      label: 'Contacts',
      id: 6,
      isHidden: value !== 5,
      Component: (
        <Box>
          <ContactTab />
        </Box>
      ),
    },
    // {
    //   label: 'Documents',
    //   id: 7,
    //   isHidden: value !== 6,
    //   Component: (
    //     <Box>
    //       <CustomBox />
    //     </Box>
    //   ),
    // },
  ];
  const handleDeleteClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (sf_token === 'true') {
      handleOpen();
    } else {
      setAnchorEl(event.currentTarget);
      setAction('delete');
    }
  };
  const handleEditModal = (event: React.MouseEvent<HTMLDivElement>) => {
    if (sf_token === 'true') {
      setEditModal(true);
    } else {
      setAnchorEl(event.currentTarget);
      setAction('edit');
    }
  };
  const editForm = (
    <ClientDrawer
      drawerState={editModal}
      typeSelected={details?.accountType?.split('_').join(' ')}
      data={details}
      setDrawerState={setEditModal}
      getAllClient={() => getDetails(params.id || '')}
    />
  );
  const handleDeleteConfirm = async (id: string) => {
    try {
      setLoading(true);
      const res = await ClientService.deleteClient(id);
      sessionStorage.removeItem('sf_delete');
      navigate('/clients');
    } catch (err) {
      setAlert('Something went wrong');
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <CustomHomepage
        CTA={
          value === 0 ? (
            <LightTooltip
              title={
                <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
                  Manage Integrations
                </Typography>
              }
              placement='bottom-end'
              style={{ backgroundColor: zeplinColor.BasicBlack, borderRadius: '8px' }}
              // sx={{ [`& .${tooltipClasses.tooltip}`]: { backgroundColor: zeplinColor.Neutral1 } }}
            >
              <Box
                sx={{ width: '100%' }}
                onClick={() => {
                  setLinkModal(true);
                }}
              >
                <CustomCard
                  styles={{
                    borderRadius: { xs: '10px', xl: '14px' },
                    padding: '15px 12px',
                    backgroundColor: zeplinColor.Neutral1,
                    ':hover': {
                      backgroundColor: zeplinColor.Neutral4,
                    },
                    border: `1px solid ${zeplinColor.BasicBlack}`,
                    cursor: 'pointer',
                    // width: '312px',
                    height: { xs: 30, xl: 48 },
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flex: 1,
                    gap: '8px',
                    // display: 'flex',
                    // flexDirection: 'column',
                    // justifyContent: 'space-between',
                  }}
                  aria-role='button'
                >
                  <img src='/assets/manage-icon.svg' width={20} height={20} alt='manage-settings' />
                  <Typography variant='responsiveButtonSmall' color={zeplinColor.BasicBlack}>
                    Manage Integrations
                  </Typography>
                </CustomCard>
              </Box>
            </LightTooltip>
          ) : (
            <></>
          )
        }
        sportsData={sportsData}
        ProfileDetails={
          <Box sx={{ display: 'flex', gap: '16px' }}>
            <Box
              sx={{
                width: { xs: '80px', xl: '100px' },
                height: { xs: '80px', xl: '100px' },
                borderRadius: '14px',
                //   border: '1px solid black',

                backgroundColor: zeplinColor.Brand1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              {captive8loading ? (
                <Skeleton variant='rounded' width={100} height={100} />
              ) : details?.avatar ? (
                <img
                  className={style['avatar']}
                  src={details?.avatar}
                  alt='logo'
                  loading='lazy'
                  style={{ objectFit: 'fill', borderRadius: '14px' }}
                />
              ) : (
                <Typography variant='display4' sx={{ color: zeplinColor.Neutral1 }}>
                  {details?.accountName
                    ?.split(' ')
                    .map((val: any, index: number) =>
                      index === 0 || index === details?.accountName?.split(' ').length - 1
                        ? val[0]
                        : '',
                    )}
                </Typography>
              )}
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                // gap: '16px',
                justifyContent: 'space-between',
              }}
            >
              <Typography
                sx={{ fontSize: { xs: '24px', xl: '36px' }, fontWeight: '300' }}
                color={zeplinColor.Neutral1}
              >
                {details?.accountName}
              </Typography>
              <Box>
                <CustomButton
                  disabled={false}
                  variant='text'
                  text={'Profile Details'}
                  textStyle={{
                    color: zeplinColor.Neutral1,
                    fontSize: '14px',
                    whiteSpace: 'nowrap',
                  }}
                  onClick={onOpen}
                  style={{
                    border: `1px solid ${zeplinColor.Neutral1}`,
                    borderRadius: '8px',
                    // width: '100%',
                    height: '32px',
                    padding: '6px 12px',
                  }}
                />
              </Box>
            </Box>
          </Box>
        }
        DealCard={
          <Box sx={{ display: 'flex', gap: '16px', flex: 1 }}>
            <DashboardDealCard
              color={Constants.DealsColor.totalDealsWon}
              val={
                +data?.totalDealsWon >= 0
                  ? `$${formatCurrency(data?.totalDealsWon) ?? 0}`
                  : undefined
              }
              percent={data?.dealsWonDelta || 0}
              text={Constants.DealsText.totalDealsWon}
            />
            <DashboardDealCard
              color={Constants.DealsColor.totalOpenDeals}
              val={
                +data?.totalOpenDeals >= 0
                  ? `$${formatCurrency(data?.totalOpenDeals) ?? 0}`
                  : undefined
              }
              percent={data?.openDealsDelta || 0}
              text={Constants.DealsText.totalOpenDeals}
            />

            <DashboardDealCard
              color={Constants.DealsColor.totalTasks}
              val={data?.totalTasks}
              text={Constants.DealsText.totalTasks}
            />
            <Link
              to={`https://${process.env.REACT_APP_SALESFORCE_URI}/lightning/page/home`}
              target='_blank'
              rel='noopener noreferrer'
              style={{ color: zeplinColor.Neutral1, textDecoration: 'none' }}
            >
              <CustomCard
                styles={{
                  borderRadius: '16px',
                  padding: '24px',
                  backgroundColor: zeplinColor.Neutral10,
                  width: '120px',
                  height: '115px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-end',
                  justifyContent: 'space-between',
                  // flex: 1,
                }}
              >
                <img src='/assets/link.svg' width={32} height={32} />
                <Typography variant='body3'>Salesforce</Typography>
              </CustomCard>
            </Link>
          </Box>
        }
        DashboardTabs={DashboardTabs}
        handleChange={handleChange}
        value={value}
        alert={alert}
        handleClose={handleClose}
        Children={
          editModal ? (
            editForm
          ) : (
            <CustomDrawer state={drawerState} onClose={onClose(false)}>
              <Box sx={{ width: { xs: '427px', xl: '527px' }, position: 'relative' }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: { xs: '30px 20px 20px 20px', xl: '40px 24px 24px 24px' },
                  }}
                >
                  <Typography variant='responsiveHeading2'>Profile Details</Typography>
                  <img
                    src={'/assets/close-icon.svg'}
                    className={style['icon']}
                    alt='close'
                    style={{ cursor: 'pointer' }}
                    onClick={onClose(false)}
                  />
                </Box>
                <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5 }} />
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: { xs: '18px', xl: '24px' },
                  }}
                >
                  {' '}
                  <Box
                    sx={{
                      display: 'flex',
                      gap: { xs: '10px', xl: '16px' },
                      padding: { xs: '20px 20px 0px 20px', xl: '24px 24px 0px 24px' },
                    }}
                  >
                    <Box
                      sx={{
                        width: { xs: '55px', xl: '60px' },
                        height: { xs: '55px', xl: '60px' },
                        borderRadius: '14px',
                        //   border: '1px solid black',

                        // backgroundColor: zeplinColor.BasicBlack,
                        // borderRadius: '14px',
                        //   border: '1px solid black',

                        backgroundColor: client?.avatar ? zeplinColor.Neutral1 : zeplinColor.Brand1,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        // overflow: 'hidden',
                      }}
                    >
                      {captive8loading ? (
                        <Skeleton variant='rounded' width={60} height={60} />
                      ) : client?.avatar ? (
                        <img
                          className={style['profile-section-avatar']}
                          src={client?.avatar}
                          alt='logo'
                          loading='lazy'
                          style={{ objectFit: 'fill', borderRadius: '14px' }}
                        />
                      ) : (
                        <Typography
                          variant='responsiveDisplay4'
                          sx={{ color: zeplinColor.Neutral1 }}
                        >
                          {details?.accountName
                            ?.split(' ')
                            .map((val: any, index: number) =>
                              index === 0 || index === details?.accountName?.split(' ').length - 1
                                ? val[0]
                                : '',
                            )}
                        </Typography>
                      )}
                    </Box>
                    <Box
                      sx={{
                        display: 'flex',
                        gap: '12px',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        flex: 1,
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          // gap: '16px',
                          justifyContent: 'space-between',
                          flex: 1,
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            // alignItems: 'center',
                            // justifyContent: 'space-between',
                          }}
                        >
                          <Box sx={{ display: 'flex', gap: '8px' }}>
                            <LightTooltip
                              title={
                                <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
                                  {details?.accountName}
                                </Typography>
                              }
                              placement='bottom-start'
                              style={{
                                backgroundColor: zeplinColor.BasicBlack,
                                borderRadius: '8px',
                              }}
                            >
                              <Typography
                                variant='responsiveDisplay5'
                                color={zeplinColor.BasicBlack}
                                style={{
                                  textDecoration: 'none',
                                  display: 'inline-block',
                                  maxWidth: '220px',
                                  overflow: 'hidden',
                                  whiteSpace: 'nowrap',
                                  textOverflow: 'ellipsis',
                                  verticalAlign: 'middle',
                                }}
                              >
                                {details?.accountName}
                              </Typography>
                            </LightTooltip>
                            {details?.league ? (
                              <Chip
                                label={
                                  <Typography
                                    variant='responsiveLabel1'
                                    color={zeplinColor.Neutral1}
                                    sx={{
                                      textAlign: 'center',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                    }}
                                  >
                                    {details?.league ?? 'NA'}
                                  </Typography>
                                }
                                sx={{
                                  backgroundColor: zeplinColor.BasicBlack,
                                  padding: '5px 12px 5px 12px',
                                  borderRadius: '50px',
                                  // width: '47px',
                                  height: '24px',
                                }}
                              />
                            ) : (
                              ''
                            )}
                          </Box>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            justifyContent: 'flex-start',
                          }}
                        >
                          {/* {details?.email && (
                            <LightTooltip
                              title={
                                <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
                                  {details?.email}
                                </Typography>
                              }
                              placement='bottom-start'
                              style={{
                                backgroundColor: zeplinColor.BasicBlack,
                                borderRadius: '8px',
                              }}
                            >
                              <a
                                href={`mailto:${details?.email}`}
                                target='_blank'
                                rel='noopener noreferrer'
                                // ensure link doesn't wrap and truncates with ellipsis
                                style={{
                                  textDecoration: 'none',
                                  display: 'inline-block',
                                  maxWidth: '220px',
                                  overflow: 'hidden',
                                  whiteSpace: 'nowrap',
                                  // textOverflow: 'ellipsis',
                                  verticalAlign: 'middle',
                                }}
                                className={style['email']}
                                title={details?.email}
                              >
                                <Typography
                                  variant='responsiveBody3'
                                  component='span'
                                  sx={{
                                    display: 'inline-block',
                                    maxWidth: '100%',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                  }}
                                >
                                  {details?.email || 'N/A'}
                                </Typography>
                              </a>
                            </LightTooltip>
                          )} */}
                          {/* <Box
                            sx={{
                              height: '16px',
                              width: '1px',
                              backgroundColor: zeplinColor.Neutral5,
                              display: 'inline-block',
                              marginX: '4px', // Add some margin on both sides
                            }}
                          /> */}
                          <Link
                            to={`https://${process.env.REACT_APP_SALESFORCE_URI}/lightning/r/Account/${params?.id}/view`}
                            target='_blank'
                            rel='noopener noreferrer'
                            style={{
                              color: zeplinColor.BasicBlack,
                              textDecoration: 'none',
                              cursor: 'pointer',
                            }}
                          >
                            <CustomCard
                              styles={{
                                borderRadius: '50px',
                                padding: '10px 10px 10px 0px',
                                backgroundColor: zeplinColor.Neutral1,
                                border: `0px solid ${zeplinColor.Neutral6}`,
                                display: 'flex',
                                gap: '4px',
                                // flexDirection: 'column',
                                alignItems: 'flex-end',
                                justifyContent: 'space-between',
                                cursor: 'pointer',
                              }}
                            >
                              <Typography variant='responsiveBody3' color={zeplinColor.Brand1}>
                                Salesforce
                              </Typography>
                              <img src='/assets/link-blue.svg' className={style['link']} />
                            </CustomCard>
                          </Link>
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: { xs: '10px', xl: '16px' },
                          alignItems: 'center',
                          // justifyContent: 'space-between',
                          // padding: '40px 24px 24px 24px',
                        }}
                      >
                        <img
                          src={'/assets/edit.svg'}
                          className={style['icon']}
                          alt='edit'
                          style={{ cursor: 'pointer' }}
                          onClick={handleEditModal}
                        />
                        <img
                          src={'/assets/copy-view.png'}
                          className={style['icon']}
                          alt='copy'
                          style={{ cursor: 'pointer' }}
                          onClick={() =>
                            handleCopyLink(
                              `https://${process.env.REACT_APP_SALESFORCE_URI}/lightning/r/Account/${params?.id}/view`,
                            )
                          }
                        />
                        <img
                          src={'/assets/delete-red.png'}
                          className={style['icon']}
                          alt='close'
                          style={{ cursor: 'pointer' }}
                          onClick={handleDeleteClick}
                        />
                      </Box>
                    </Box>
                    <CustomPopOver
                      setAnchorEl={setAnchorEl}
                      anchorEl={anchorEl}
                      id={id}
                      sx={{
                        borderRadius: '14px',
                        boxShadow: 'rgba(0, 0, 0, 0.15)',
                        marginTop: '8px',
                        // marginRight: '2rem',
                        // marginLeft: '-4rem',
                      }}
                    >
                      <Box
                        sx={{
                          height: '202px',
                          width: '340px',
                          padding: '24px',
                          display: 'flex',
                          gap: '32px',
                          flexDirection: 'column',
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            gap: { xs: '10px', xl: '16px' },
                            flexDirection: 'column',
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              gap: { xs: '6px', xl: '12px' },
                              justifyContent: 'space-between',
                            }}
                          >
                            <Typography variant='responsiveHeading3' color={zeplinColor.BasicBlack}>
                              Authentication Required
                            </Typography>
                            <img
                              src={'/assets/close-icon.svg'}
                              className={style['icon']}
                              alt='close'
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                setAnchorEl(null);
                              }}
                            />
                          </Box>

                          <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
                            {/* To create a new task, please ensure you're logged in to your Salesforce account. */}
                            You need to be logged into Salesforce to perform this action. Please log
                            in to your Salesforce account.
                          </Typography>
                        </Box>
                        <Link
                          // target='_blank'
                          // rel='noopener noreferrer'
                          to={`https://${process.env.REACT_APP_SALESFORCE_URI}/services/oauth2/authorize?client_id=${process.env.REACT_APP_CLIENT_SALESFORCE}&redirect_uri=${process.env.REACT_APP_REDIRECT}&response_type=code`}
                        >
                          <CustomButton
                            disabled={false}
                            onClick={() => {
                              setOpenModal(false);

                              sessionStorage.setItem('sf_redirect', 'Task');
                              // sessionStorage.setItem('sf_edit_selected', JSON.stringify(selected));

                              sessionStorage.setItem('sf_path', location?.pathname);
                              action === 'edit'
                                ? sessionStorage.setItem('sf_edit', 'true')
                                : sessionStorage.setItem('sf_delete', 'true');
                            }}
                            variant='contained'
                            color={'primary'}
                            style={{
                              width: '155px',
                              borderRadius: '14px',
                              height: '48px',
                              padding: '14px 16px',
                              '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
                            }}
                            textStyle={{ color: zeplinColor.Neutral1 }}
                            text={'Open Salesforce'}
                            // tabindex={4}
                          />
                        </Link>
                      </Box>
                    </CustomPopOver>
                  </Box>
                  {details?.accountType?.split('_').join(' ') === ClientType?.Talent && (
                    <TalentDetails loading={loading} details={details} />
                  )}
                  {details?.accountType?.split('_').join(' ') === ClientType?.Athlete && (
                    <AtheleteDetails loading={loading} details={details} />
                  )}
                  {details?.accountType?.split('_').join(' ') === ClientType?.Business && (
                    <BusinessDetails loading={loading} details={details} />
                  )}
                </Box>
              </Box>
            </CustomDrawer>
          )
        }
      />
      <CustomModal handleClose={() => setOpenModal(false)} open={openModal}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <CustomCard
            styles={{
              borderRadius: '14px',
              padding: { xs: '20px', xl: '24px' },
              backgroundColor: zeplinColor.Neutral1,

              // width: '312px',
              // height: '201px',
              boxShadow: 'rgba(0, 0, 0, 0.15)',
              // display: 'flex',
              // flexDirection: 'column',
              // justifyContent: 'space-between',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: { xs: '22px', xl: '32px' },
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: { xs: '10px', xl: '16px' },
                }}
              >
                <Typography variant='heading3' color={zeplinColor.BasicBlack}>
                  Delete Client?
                </Typography>
                <Typography variant='body2' color={zeplinColor.BasicBlack}>
                  You’re about to permanently delete{' '}
                  <Typography variant='responsiveHeading4'>{details?.accountName}</Typography>
                  <br /> and all related data. This action can’t be
                  <br /> undone. Are you sure you want to proceed?
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',

                  gap: { xs: '10px', xl: '16px' },
                }}
              >
                <Box
                  onClick={() => {
                    setOpenModal(false);
                    sessionStorage.removeItem('sf_delete');
                  }}
                  sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
                >
                  <CustomCard
                    styles={{
                      borderRadius: '14px',
                      padding: '14px 32px',
                      backgroundColor: zeplinColor.Neutral1,
                      border: `1px solid ${zeplinColor.BasicBlack}`,
                      cursor: 'pointer',
                      // width: '312px',
                      // height: '183px',
                      display: 'flex',
                      justifyContent: 'center',
                      flex: 1,
                      // display: 'flex',
                      // flexDirection: 'column',
                      // justifyContent: 'space-between',
                    }}
                    aria-role='button'
                    aria-disable={loading}
                  >
                    <Typography variant='buttonMedium' color={zeplinColor.BasicBlack}>
                      Cancel
                    </Typography>
                  </CustomCard>
                </Box>
                <Box
                  onClick={() => {
                    handleDeleteConfirm(details?.accountId);
                  }}
                  sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
                >
                  <CustomCard
                    styles={{
                      borderRadius: '14px',
                      padding: '14px 32px',
                      backgroundColor: zeplinColor.Error,
                      cursor: 'pointer',
                      // border: `1px solid ${zeplinColor.BasicBlack}`,
                      // width: '312px',
                      // height: '183px',
                      display: 'flex',
                      justifyContent: 'center',
                      flex: 1,
                      // display: 'flex',
                      // flexDirection: 'column',
                      // justifyContent: 'space-between',
                    }}
                    aria-role='button'
                    aria-disable={loading}
                  >
                    <Typography
                      variant='buttonMedium'
                      color={zeplinColor.Neutral1}
                      sx={{ whiteSpace: 'nowrap', textAlign: 'center' }}
                    >
                      {loading ? 'Deleting...' : 'Delete'}
                    </Typography>
                  </CustomCard>
                </Box>
              </Box>
            </Box>
          </CustomCard>
          {/* {loading ? <CustomLoader /> : ''} */}
        </Box>
      </CustomModal>
      <LinkingForm
        modalOpen={linkModal}
        setLinkModal={setLinkModal}
        clientId={client?.AccountId}
        client={client}
        getAllClient={() => {
          getDetails(params.id || '');
        }}
      />
    </>
  );
};

export default ClientSelected;
